import {
  DOCUMENT_SIGN_FAIL,
  DOCUMENT_SIGN_REQUEST,
  DOCUMENT_SIGN_SUCCESS,
} from '../constants/documentConstants'

export const documentReducer = (state = {}, action) => {
  switch (action.type) {
    case DOCUMENT_SIGN_REQUEST:
      return { loading: true }
    case DOCUMENT_SIGN_SUCCESS:
      return {
        loading: false,
        success: true,
        signature_request: action.payload,
      }
    case DOCUMENT_SIGN_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}
